export default __webpack_public_path__ + "static/media/M46.3bc3208f.svg";